import { type FieldMetadata, getTextareaProps } from '@conform-to/react'
import {
	type TextAreaProps as RadixTextAreaProps,
	TextArea as RadixTextArea,
	Box,
	Flex,
} from '@radix-ui/themes'
import { type TFunction } from 'i18next'
import * as React from 'react'

import { FormFieldError } from '#app/components/ui/form-field-error.tsx'
import { type LabelProps, Label } from '#app/components/ui/label/label.tsx'

/* -------------------------------------------------------------------------------------------------
 * TextArea
 * -----------------------------------------------------------------------------------------------*/

type TextAreaElement = React.ElementRef<typeof RadixTextArea>
type TextAreaProps = React.PropsWithoutRef<RadixTextAreaProps> &
	Pick<LabelProps, 'children'> & {
		meta: FieldMetadata<string>
		t: TFunction<string, undefined>
	}

const TextArea = React.forwardRef<TextAreaElement, TextAreaProps>(
	(props, forwardedRef) => {
		const {
			children = props.t(`label.${props.name}`),
			className,
			meta,
			t,
			...rest
		} = props

		return (
			<Flex direction="column" width="100%">
				<Box position="relative" pl="1" className="app-TextAreaBox">
					<RadixTextArea
						ref={forwardedRef}
						{...getTextareaProps(meta)}
						placeholder=" "
						{...rest}
					/>
					<Label htmlFor={meta.id} color="gray">
						{children}
					</Label>
				</Box>
				{!!meta.errors && <FormFieldError error={meta.errors[0]} t={t} />}
			</Flex>
		)
	},
)
TextArea.displayName = 'TextArea'

/* -----------------------------------------------------------------------------------------------*/

export { TextArea }
